import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Input from "./../../Input/Input";
import http from "../../../Services/http";
import Loader from "react-loader-spinner";

const EditFoods = ({ props }) => {
  const [food, setFood] = useState();
  const [, setLoader] = useState();
  const foodID = props.match.params.id;
  useEffect(() => {
    const fetchFood = async () => {
      const { data } = await http.get(`/foods/${foodID}`);
      setFood(data.food);
    };

    fetchFood();
  }, [foodID]);

  const updateFood = async (values) => {
    try {
      setLoader(true);
      await http.patch(`/foods/${props.match.params.id}`, values, {
        headers: {
          "x-token": localStorage.getItem("token"),
        },
      });
      window.location = "/dashborad";
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const editFoodSchema = Yup.object().shape({
    title: Yup.string()
      .required("title can not be empty")
      .min(5, "title can not be less than 5 letters")
      .max(100, "title can not be more than 100 letters"),
    desc: Yup.string()
      .required("desc can not be empty")
      .min(10, "desc can not be less than 10 letters")
      .max(500, "desc can not be more than 500 letters"),
    price: Yup.number()
      .required("price can not be empty")
      .min(5, "price can not be less than 5 letters")
      .max(100, "price can not be more than 100 letters"),
    quantity: Yup.boolean(),
  });

  return (
    <div className="edit__foods">
      {food ? (
        <React.Fragment>
          <Formik
            initialValues={{
              title: food.title,
              desc: food.desc,
              price: food.price,
              quantity: food.quantity,
            }}
            validationSchema={editFoodSchema}
            onSubmit={updateFood}
          >
            {({
              values,
              errors,
              handleChange,
              setFieldValue,
              handleSubmit,
            }) => (
              <Form>
                <Input
                  value={values.title}
                  onchange={handleChange}
                  error={errors.title}
                  name="title"
                  type="text"
                  placeholder="enter your title"
                />
                <Input
                  value={values.desc}
                  onchange={handleChange}
                  error={errors.desc}
                  name="desc"
                  type="text"
                  placeholder="enter your desc"
                />

                <Input
                  value={values.price}
                  onchange={handleChange}
                  error={errors.price}
                  name="price"
                  type="number"
                  placeholder="enter your price"
                />

                {
                  <Field
                    as="select"
                    name="quantity"
                    className="form__input"
                    handleChange={(value) => setFieldValue("quantity", value)}
                  >
                    <option value="true">Available</option>
                    <option value="false">Not Available</option>
                  </Field>
                }

                <button
                  className="btn btn-signup"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </Form>
            )}
          </Formik>
        </React.Fragment>
      ) : (
        <Loader type="ThreeDots" color="#ef92c8" height={200} width={200} />
      )}
    </div>
  );
};

export default EditFoods;
